import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=e7147442&scoped=true"
import script from "./list2.vue?vue&type=script&lang=js"
export * from "./list2.vue?vue&type=script&lang=js"
import style0 from "./list2.vue?vue&type=style&index=0&id=e7147442&prod&lang=scss&scoped=true"
import style1 from "./list2.vue?vue&type=style&index=1&id=e7147442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7147442",
  null
  
)

export default component.exports